<div class="auth register">
  <div class="auth__header flex flex-col gap-4 text-center">
    <h2 translate>Create Account</h2>
    <p translate>Please Enter Your Information</p>
  </div>

  <form class="flex flex-col gap-4" [formGroup]="form" (submit)="submit()">
    <input-text [options]="{
        label: 'Email',
        control: form.controls.email,
        isShowErrors: isShowErrors,
      }"></input-text>
    <input-password [options]="{
        label: 'Password',
        control: form.controls.password,
        isShowErrors: isShowErrors,
      }"></input-password>
    <input-password [options]="{
        label: 'Confirm Password',
        control: form.controls.confirmPassword,
        isShowErrors: isShowErrors,
      }"></input-password>
    <div class="w-full flex justify-center">
      <input-recaptcha [options]="{
          control: form.controls.recaptcha,
          isShowErrors: isShowErrors,
        }"></input-recaptcha>
    </div>

    <!-- <input-check-robot
      [options]="{
        control: form.controls.recaptcha,
        isShowErrors: isShowErrors,
      }"
    ></input-check-robot> -->

    <button type="submit" class="primary__btn mt-2" translate>Sign Up</button>
  </form>
  <p class="account__status text-center mt-7">
    {{ "Already Have Account ?" | translate }}
    <app-anchor to="login" text="Login" [preventIf]="authModalService.isInModal"
      (onClick)="authModalService.goLogin()"></app-anchor>
  </p>

  <div class="mt-6">
    <app-openid-authentication></app-openid-authentication>
  </div>
</div>